/** Asset paths under `public/` and `public/images/` — keep filenames in sync with files on disk. */
export const SITE_IMAGES = {
  logo: '/favicon.png',
  heroBackground: '/images/background.png',
  bizCard: '/images/BizCard.png',
  proscapeInfo: '/images/Proscapeinfo.png',
};

/**
 * Gallery rows:
 * - `beforeAfter` — true before / after
 * - `workPair` — one or more finished shots (no before/after labels)
 */
export const GALLERY_ITEMS = [
  {
    type: 'beforeAfter',
    title: 'Bush trimming',
    before: '/images/before_trim.jpg',
    after: '/images/after_trim.jpg',
    beforeAlt: 'Shrubs and hedges before trimming',
    afterAlt: 'Same beds after professional bush trimming',
  },
  {
    type: 'beforeAfter',
    title: 'Retaining wall',
    before: '/images/before_wall.jpg',
    after: '/images/after_wall.jpg',
    beforeAlt: 'Wall project before completion',
    afterAlt: 'Wall project after completion',
  },
  {
    type: 'beforeAfter',
    title: 'Lawn mowing',
    before: '/images/before_grass2.jpg',
    after: '/images/after_grass2.jpg',
    beforeAlt: 'Lawn mowing before completion',
    afterAlt: 'Lawn mowing after completion',
  },
  {
    type: 'beforeAfter',
    title: 'Clean Up',
    before: '/images/before_rake.jpg',
    after: '/images/after_rake.jpg',
    beforeAlt: 'Clean Up before completion',
    afterAlt: 'Clean Up after completion',
  },
  {
    type: 'workPair',
    title: 'Completed lawns',
    photos: [
      { src: '/images/lawn1.jpg', alt: 'Completed lawn — healthy turf and clean edges' },
      { src: '/images/lawn2.jpg', alt: 'Completed lawn — striped mowing finish' },
      { src: '/images/lawn3.jpg', alt: 'Completed lawn — landscaped yard' },
      { src: '/images/lawn4.jpg', alt: 'Completed lawn — professional landscaping' },
      { src: '/images/lawn5.jpg', alt: 'Completed lawn — manicured grass' },
      { src: '/images/lawn6.jpg', alt: 'Completed lawn — pristine yard' },
    ],
  },
];
